export interface ChiguaArticle {
  id: string;
  channel: string;
  title: string;
  summary: string;
  time: string;
  readingTime: string;
  views: string;
  comments: string;
  likes: string;
  hot: boolean;
  tags: string[];
  image: string;
  content: string[];
}

export interface Channel {
  key: string;
  name: string;
  desc: string;
  icon: string;
  tagline: string;
}

export const channels: Channel[] = [
  {
    key: "yule",
    name: "娱乐八卦",
    desc: "影视剧综、音乐现场、艺人动态的一手吃瓜现场",
    icon: "ri-vip-crown-2-line",
    tagline: "明星 · 综艺 · 红毯",
  },
  {
    key: "shehui",
    name: "社会热点",
    desc: "城市街头与民生百态里的热议话题速览",
    icon: "ri-flashlight-line",
    tagline: "民生 · 城市 · 百态",
  },
  {
    key: "wangluo",
    name: "网络热议",
    desc: "热搜趋势、直播八卦、网友考古的名场面合集",
    icon: "ri-fire-line",
    tagline: "热搜 · 直播 · 名场面",
  },
  {
    key: "hangye",
    name: "行业内幕",
    desc: "职场、品牌与商业圈里的那些事儿",
    icon: "ri-briefcase-4-line",
    tagline: "职场 · 品牌 · 商业",
  },
];

export const channelName = (key: string): string =>
  channels.find((c) => c.key === key)?.name ?? "吃瓜资讯";

export const articles: ChiguaArticle[] = [
  {
    id: "yule-01",
    channel: "yule",
    title: "新晋顶流男团巡演被曝「假唱疑云」，粉丝现场拍下口型对不上瞬间",
    summary:
      "某刚走红不久的组合巡演首站结束后，网上流出多段「歌声与口型不同步」的现场片段，引发真假唱大讨论，经纪公司暂未正面回应。",
    time: "18分钟前",
    readingTime: "3分钟",
    views: "86.3万",
    comments: "4200",
    likes: "1.2万",
    hot: true,
    tags: ["男团", "巡演", "假唱疑云"],
    image:
      "https://readdy.ai/api/search-image?query=Large%20concert%20stage%20with%20colorful%20spotlights%20and%20smoke%20effects%20viewed%20from%20crowd%2C%20vibrant%20warm%20red%20and%20orange%20lighting%2C%20editorial%20style%2C%20cinematic%2C%20no%20clear%20faces%2C%20dreamy%20atmosphere&width=1280&height=720&seq=chigua-yule01&orientation=landscape",
    content: [
      "「今天吃瓜」小编收到多位现场观众的投稿：在刚刚结束的某当红男团巡演首站现场，有歌迷拍下了数段演出画面，画面中舞台上的歌手在演唱高音段落时，话筒明明已经放下，耳返里却仍传出清晰的歌声，现场不少人都当场发现了口型与歌声对不上的情况。",
      "这些片段被陆续搬运到各大短视频平台后迅速发酵。有专业音频爱好者对现场收音进行分析，指出副歌部分的声压与人声细节与录音室版本高度吻合，怀疑现场采用的是预录音轨。不过也有理性歌迷表示，大型巡演普遍会加入半开麦处理，仅凭几段画面很难下定论。",
      "截至目前，涉事经纪公司尚未就「假唱疑云」作出正式回应，组合官方后援会则呼吁大家等待官方说明、理性吃瓜，不要传播未经剪辑的片段。事情究竟会如何发展，我们会持续跟进出后续进展。",
      "理性吃瓜提示：网络爆料与现场片段仍需更多证据佐证，请大家在官方消息出来前保持克制，让子弹再飞一会儿。",
    ],
  },
  {
    id: "yule-02",
    channel: "yule",
    title: "时隔八年两位「老搭档」再度同框，红毯旧照被网友考古翻红",
    summary:
      "一张多年前的颁奖礼同框旧照因两人本周再度合作被重新翻出，网友纷纷表示「这波回忆杀直接拉满」，相关话题冲上娱乐榜前列。",
    time: "1小时前",
    readingTime: "2分钟",
    views: "54.1万",
    comments: "2300",
    likes: "8600",
    hot: true,
    tags: ["同框", "回忆杀", "颁奖礼"],
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20backdrop%20with%20soft%20golden%20bokeh%20lights%20and%20camera%20flashes%2C%20warm%20amber%20tones%2C%20cinematic%20editorial%20photography%2C%20atmospheric%20no%20faces&width=1280&height=720&seq=chigua-yule02&orientation=landscape",
    content: [
      "本周娱乐圈最让人「原地复活」的一幕，当属两位阔别多年未再合作的老搭档官宣再次同台。消息一出，评论区立刻被一片「爷青回」刷屏，还有人第一时间翻出八年前两人同台领奖的那张经典旧照。",
      "旧照里两人一红一黑的造型、略显青涩的神态，与现在成熟稳重的状态形成鲜明对比，被网友戏称为「时间的答案」。考古帖底下一时间满是各种年代的回忆，从入坑作品到嗑过的剧集CP，聊得不亦乐乎。",
      "据了解，这次合作源于一档以「致敬经典」为主题的综艺企划，节目组专程把多年未同框的两人请回舞台。目前官方只放出了一张海报和一段短短的花絮，却已经让相关讨论热度居高不下。",
      "理性吃瓜提示：同框是节目组的安排，磕CP的网友还请保持分寸，静静期待正片就好。",
    ],
  },
  {
    id: "yule-03",
    channel: "yule",
    title: "导演新片开拍前「临阵换角」，投资方与经纪团队各执一词",
    summary:
      "某备受关注的文艺片开机前一周传出换角消息，双方说法不一：一边称档期冲突，一边暗示存在「不可调和的分歧」，粉丝议论纷纷。",
    time: "3小时前",
    readingTime: "4分钟",
    views: "32.7万",
    comments: "1600",
    likes: "4200",
    hot: false,
    tags: ["新片", "换角", "争议"],
    image:
      "https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%20with%20clapperboard%20and%20warm%20studio%20lights%2C%20cinematic%20moody%20atmosphere%2C%20editorial%20photography%2C%20no%20people&width=1280&height=720&seq=chigua-yule03&orientation=landscape",
    content: [
      "距离正式开机只剩一周，某知名导演筹备多年的文艺新片突然被曝出「临时换角」。最初有娱乐号爆料称，原定领衔主演因档期问题无法入组，投资方正在紧急接洽备选演员。",
      "然而不到半天，涉事演员的经纪团队就发文澄清，强调「档期从开始就预留了足够时间」，言下之意明显指向另有内情。导演本人则在朋友圈语气微妙地回应「好的作品值得等」，被解读为对选角仍有坚持。",
      "多方消息交错之下，粉丝与路人纷纷站队。有人心疼筹备多年的导演，也有人质疑是不是有人「把剧组当跳板」。目前新片官微只简单表示「阵容调整中，一切以官宣为准」，留下大量悬念。",
      "理性吃瓜提示：剧组选角本就是常态调整，具体原因外人难知全貌，建议大家少一点脑补，多一点等待。",
    ],
  },
  {
    id: "shehui-01",
    channel: "shehui",
    title: "老小区里开了十二年的早餐摊突然歇业，熟客们排队留字条致谢",
    summary:
      "一个经营了十二年的街角早餐摊因店主退休而停业，最后一早上百位熟客自发前来道别，留下的暖心字条看哭路人，话题温暖刷屏。",
    time: "40分钟前",
    readingTime: "2分钟",
    views: "92.8万",
    comments: "3800",
    likes: "3.5万",
    hot: true,
    tags: ["暖心", "市井", "人情味"],
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20morning%20street%20breakfast%20stall%20with%20steaming%20steamer%20and%20handwritten%20notes%20pinned%20on%20board%2C%20warm%20morning%20sunlight%2C%20nostalgic%20warm%20tones%2C%20documentary%20style&width=1280&height=720&seq=chigua-shehui01&orientation=landscape",
    content: [
      "在这座城市的旧街区里，有一家不起眼的早餐摊，一开就是十二年。店主夫妻俩每天凌晨三点起床和面，靠着几张桌子和一口热腾腾的蒸笼，喂大了不少街坊孩子，也陪一批又一批上班族走过了通勤的清晨。",
      "本周，摊主在门口贴出告示：因年纪渐长，决定正式歇业。消息传开后，最后一天清晨不到六点，摊位前就排起了长队。除了照常买早餐的熟客，更多人是专程赶来道别，还有人把想说的话写在便签上，贴满了摊位的布帘和立柱。",
      "字条内容五花八门又句句戳心——「谢谢老板娘记得我不吃香菜」「从学生吃到上班，这里就是我的食堂」「希望退休后能睡个好觉」。摊主收摊时看着满满一帘字条红了眼眶，说要全部收好带回家。",
      "理性吃瓜提示：这就是市井生活最动人的地方。愿每一份用心经营的烟火气，都能被温柔以待。",
    ],
  },
  {
    id: "shehui-02",
    channel: "shehui",
    title: "城市地铁「让座风波」再引热议：年轻人该不该为老人主动起身",
    summary:
      "一段早高峰地铁上「年轻人未让座被拍」的短视频引发两极讨论，有人批评礼让传统流失，也有人认为高峰拥挤不该被道德绑架，你怎么看？",
    time: "2小时前",
    readingTime: "3分钟",
    views: "61.5万",
    comments: "5100",
    likes: "6800",
    hot: true,
    tags: ["地铁", "让座", "热议"],
    image:
      "https://readdy.ai/api/search-image?query=Crowded%20city%20subway%20car%20interior%20with%20commuters%2C%20blurred%20motion%20and%20warm%20car%20lighting%2C%20candid%20documentary%20photo%2C%20no%20clear%20faces%2C%20urban%20atmosphere&width=1280&height=720&seq=chigua-shehui02&orientation=landscape",
    content: [
      "最近一段早高峰地铁车厢内的短视频在网上广泛传播。画面中，一位头发花白的老人上车后站了许久，坐在「爱心专座」旁的年轻乘客戴着耳机似乎并未察觉。拍摄者随即配文指责年轻人「不懂礼让」，这条视频很快登上热搜。",
      "然而评论区并未一边倒。不少人认为高峰时段车厢拥挤，年轻人通勤疲惫同样值得体谅；也有人指出「让座是情分不是本分」，更不该被随手拍成网络审判。两种声音你来我往，把「让座到底是不是义务」这一老话题再度推向风口浪尖。",
      "有社会学观点指出，让座问题的本质是公共空间里代际与个体权利之间的平衡，与其苛责某一位乘客，不如推动公交更合理的设施设计与更友善的提醒机制。",
      "理性吃瓜提示：一次让座反映不了一个人的全部，遇到需要帮助的乘客，主动问一声、让一步，才是城市里最舒服的相处方式。",
    ],
  },
  {
    id: "shehui-03",
    channel: "shehui",
    title: "高校食堂「一元菜」窗口走红，学生晒账单：吃饭竟成最省钱的事",
    summary:
      "一所高校食堂坚持十余年供应「一元菜」「爱心餐」，最近被学生晒到网上走红。校方回应会一直把平价窗口做下去，不少网友直呼「别人家的大学」。",
    time: "5小时前",
    readingTime: "2分钟",
    views: "48.9万",
    comments: "2700",
    likes: "2.1万",
    hot: false,
    tags: ["高校", "食堂", "平价"],
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20university%20cafeteria%20with%20steaming%20food%20counter%20and%20student%20trays%2C%20warm%20natural%20lighting%2C%20cheerful%20atmosphere%2C%20editorial%20photography%2C%20no%20faces&width=1280&height=720&seq=chigua-shehui03&orientation=landscape",
    content: [
      "这几天，一所高校的食堂因为一道特殊的窗口被顶上了热搜——每天限量供应的「一元菜」，荤素搭配、份量实在，一卖就是十几年。有学生随手拍了打菜的账单晒到网上：「没想到上了大学，吃饭竟然成了最省钱的事。」",
      "视频引发大量共鸣后，更多该校学生接力晒出自己的一元餐，土豆炖肉、番茄鸡蛋、清炒时蔬轮番上桌，评论区一片「神仙食堂」「看完想报考」的羡慕声。",
      "校方随后回应，这个平价窗口最初是为了照顾经济困难的同学开设的，如今已经成为学校多年的传统，只要还有学生在，窗口就会一直开下去。食堂阿姨朴实的一句「能让学生吃好，我们就高兴」，让无数网友破防。",
      "理性吃瓜提示：一份温暖人心的平价饭菜，恰恰是校园最动人的「招牌菜」，也希望这样的食堂越来越多。",
    ],
  },
  {
    id: "wangluo-01",
    channel: "wangluo",
    title: "主播深夜直播「翻车」现场走红：口误念错金主品牌名，场面一度尴尬",
    summary:
      "一场深夜带货直播里，主播因紧张把品牌名念成谐音梗，弹幕瞬间刷屏，主播本人愣住后自嘲化解，意外把冷门单品卖到断货，堪称教科书式补救。",
    time: "1小时前",
    readingTime: "3分钟",
    views: "75.2万",
    comments: "3600",
    likes: "1.5万",
    hot: true,
    tags: ["直播", "翻车", "救场"],
    image:
      "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20ring%20light%20and%20phone%20and%20product%20boxes%2C%20vibrant%20pink%20and%20orange%20neon%20glow%2C%20energetic%20atmosphere%2C%20editorial%20style%2C%20no%20faces&width=1280&height=720&seq=chigua-wangluo01&orientation=landscape",
    content: [
      "凌晨的直播间里，一场原以为会平平无奇的带货直播，却因主播一句口误彻底「出圈」。当时正在介绍某品牌新款保温杯，主播一紧张竟把品牌名念成了一个相近的谐音梗，话音刚落，弹幕就像开了闸一样刷屏：「这波是品牌黑话还是带货黑话？」",
      "意识到自己口误后，主播明显愣了一下，随即一拍大腿自嘲：「完了，这下金主爸爸要找我聊人生了。」没想到这份坦然反而让观众好感度暴涨，评论区纷纷表示「就冲这反应，冲了」，原本计划带货量平平的冷门颜色款直接被拍到售罄。",
      "事后主播在动态里专门向品牌方致歉，品牌官方则顺势玩梗回应，把「口误款」做成了限定话题，一场乌龙硬生生变成了双方联动的营销经典案例。",
      "理性吃瓜提示：面对突发状况，与其尴尬不如坦诚，好的临场反应本身就是最好的广告。",
    ],
  },
  {
    id: "wangluo-02",
    channel: "wangluo",
    title: "「考古风」短视频集体翻红：多年前的综艺名场面为何越看越上头",
    summary:
      "一段时间以来，一大批早年的综艺、晚会片段被网友重新剪辑翻红，成了新的「电子榨菜」。老内容为何能持续产出新梗？我们聊了聊背后的现象。",
    time: "4小时前",
    readingTime: "4分钟",
    views: "39.4万",
    comments: "1900",
    likes: "7300",
    hot: false,
    tags: ["考古", "名场面", "现象"],
    image:
      "https://readdy.ai/api/search-image?query=Old%20school%20television%20screen%20playing%20retro%20variety%20show%20with%20static%20glow%2C%20nostalgic%20warm%20tones%20and%20vintage%20ambience%2C%20creative%20editorial%20visual&width=1280&height=720&seq=chigua-wangluo02&orientation=landscape",
    content: [
      "如果你最近刷短视频，大概率躲不开这样一类内容：多年前的老综艺片段被配上新的解说、新的BGM，重新包装成「考古现场」推到你面前。评论区最常见的留言，是那句熟悉的「这我居然没看过」「当年竟然错过了这么好笑的名场面」。",
      "为什么已经过去十年甚至更久的片段，反而越看越上头？有内容从业者分析，一是老片段天然带着「时代滤镜」，能唤起观众的集体怀旧；二是因为当时的真人秀更注重真实反应，反而比今天层层设防的综艺更有「活人感」。",
      "更重要的是，新一批年轻观众没看过原作，考古视频对他们来说就是「全新的内容」，加上网友不断在原片上挖掘新细节、造出新梗，让老素材源源不断长出「第二春」。",
      "理性吃瓜提示：好内容的生命力从来不会被时间轻易埋没，也期待当下的节目，能给未来留下更多值得考古的片段。",
    ],
  },
  {
    id: "wangluo-03",
    channel: "wangluo",
    title: "网友晒「素颜挑战」翻车合集，评论区：原来大家都一样",
    summary:
      "一场「素颜也要美」的挑战在社交平台刷屏，无数网友勇敢晒出无滤镜原相机照片。翻车与搞笑齐飞的背后，是关于「容貌焦虑」的一次集体松绑。",
    time: "8小时前",
    readingTime: "2分钟",
    views: "44.6万",
    comments: "3100",
    likes: "2.9万",
    hot: false,
    tags: ["素颜", "挑战", "容貌焦虑"],
    image:
      "https://readdy.ai/api/search-image?query=Collection%20of%20fun%20selfie%20mirror%20shots%20and%20phone%20screens%20in%20collage%2C%20bright%20natural%20daylight%2C%20playful%20cheerful%20energy%2C%20warm%20tone%2C%20creative%20editorial%20still%20life%2C%20no%20clear%20faces&width=1280&height=720&seq=chigua-wangluo03&orientation=landscape",
    content: [
      "社交平台上最近兴起一股「素颜挑战」风潮：参与者放下滤镜和美颜，用手机原相机在自然光下拍下自己最真实的模样。短短几天，话题下就聚集了数以万计的分享，画风从精致到「灾难现场」应有尽有。",
      "有趣的是，真正引发刷屏的不是「谁更美」，而是一大波大方自嘲的「翻车合集」——睡乱的头发、熬出来的黑眼圈、起皮的脸颊，配上「我就是普通人的样子」的文案，反而收获海量点赞。",
      "有观点认为，这场看似搞笑的挑战，其实是年轻人在「容貌焦虑」席卷多年之后，进行的一次集体松绑：当越来越多的人敢于展示不加修饰的真实，那个被算法不断拉高的「颜值标准」，也在一点点被拉回人间。",
      "理性吃瓜提示：滤镜外的你，本来就很真实也很美。愿每个刷到这条的人，都能少一点容貌焦虑，多一点爱自己。",
    ],
  },
  {
    id: "hangye-01",
    channel: "hangye",
    title: "大厂员工晒「佛系下班」引热议：拒绝无效加班的年轻人越来越多",
    summary:
      "一位大厂员工到点准时收工、拒绝无效加班的自述走红网络。评论区炸开了锅：当「奋斗文化」撞上「准点下班」，职场人的心态正在悄悄改变。",
    time: "3小时前",
    readingTime: "4分钟",
    views: "58.7万",
    comments: "4400",
    likes: "1.1万",
    hot: true,
    tags: ["大厂", "加班", "职场"],
    image:
      "https://readdy.ai/api/search-image?query=Modern%20office%20worker%20leaving%20with%20backpack%20at%20dusk%20from%20high%20rise%20building%20through%20glass%20doors%2C%20warm%20sunset%20light%2C%20reflective%20city%2C%20documentary%20editorial%20style%2C%20back%20view%20no%20face&width=1280&height=720&seq=chigua-hangye01&orientation=landscape",
    content: [
      "一位互联网大厂的员工近日发帖自述，自己坚持每天到点准时下班，「任务没做完，明天再说；领导没走，也不代表我要表演加班」。这条看似普通的帖子，却在打工人的圈子里炸开了锅，转发和讨论持续走高。",
      "评论区呈现出清晰的代际分野：一些前辈感慨「现在的年轻人躺平意识太强」，而更多年轻网友则反驳，「我们反对的不是努力，而是毫无意义的无效加班」。两方你来我往，把「奋斗与休息」这对老矛盾再次摆上台面。",
      "值得注意的细节是，发帖人特别强调，自己并非不努力工作，而是把效率放在首位，拒绝「用加班时长表演忠诚」。有管理观察人士指出，越来越多企业开始关注员工的实际产出而非工时，或许正是对这一趋势的回应。",
      "理性吃瓜提示：工作是为了更好的生活，在合理范围内守住自己的边界，从来都不丢人。",
    ],
  },
  {
    id: "hangye-02",
    channel: "hangye",
    title: "连锁奶茶店「半杯都是冰」遭吐槽，官方回应将上线「去冰加量」选项",
    summary:
      "多位网友晒出奶茶「半杯冰」照片吐槽分量，相关连锁品牌紧急回应致歉，并宣布将上线更人性化的温度与容量选项，网友：这波还算是听劝。",
    time: "6小时前",
    readingTime: "2分钟",
    views: "46.3万",
    comments: "3900",
    likes: "9400",
    hot: false,
    tags: ["奶茶", "品牌", "回应"],
    image:
      "https://readdy.ai/api/search-image?query=Refreshing%20iced%20milk%20tea%20cups%20with%20clear%20ice%20cubes%20on%20warm%20wooden%20counter%2C%20fresh%20fruit%20decor%2C%20bright%20appetizing%20warm%20lighting%2C%20commercial%20product%20photography%2C%20no%20faces&width=1280&height=720&seq=chigua-hangye02&orientation=landscape",
    content: [
      "「点一杯大杯，半杯都是冰，奶茶全靠捞。」这两天，关于某连锁奶茶品牌「冰量过多」的吐槽集中爆发，多位网友晒出外卖截图和实拍照片，直言「花大杯的钱，喝小杯的量」。相关话题很快冲上社交平台热榜。",
      "面对舆论，品牌方连夜作出回应：对给顾客带来的不佳体验致歉，并宣布将在线下门店和点单小程序同步上线「少冰」「去冰加量」等更细分的温度与容量选项，同时承诺将对饮品制作标准进行复核。",
      "回应发布后，不少此前吐槽的网友态度有所缓和，表示「知错就改、还算听劝」。也有业内人士提醒，冷饮缩量是行业普遍的「潜规则」，此次个别品牌率先松口，有望带动整个行业重新审视分量透明化的问题。",
      "理性吃瓜提示：消费体验的事，就是一件件小事拼出来的口碑。品牌愿意听劝，对消费者而言终究是件好事。",
    ],
  },
  {
    id: "hangye-03",
    channel: "hangye",
    title: "「00后」组团接线下店「改造生意」，一杯咖啡钱买走老板们的焦虑",
    summary:
      "一群平均二十岁出头的年轻团队，专门帮传统小店做门店形象与线上引流改造，用一套组合拳盘活了不少冷清的老店，这门新生意正在走红。",
    time: "10小时前",
    readingTime: "3分钟",
    views: "28.1万",
    comments: "1300",
    likes: "5600",
    hot: false,
    tags: ["00后", "创业", "实体店"],
    image:
      "https://readdy.ai/api/search-image?query=Young%20creative%20team%20meeting%20in%20renovated%20cozy%20small%20shop%20with%20sketchbook%20and%20laptop%2C%20warm%20afternoon%20light%2C%20energetic%20collaboration%20atmosphere%2C%20documentary%20style%2C%20no%20clear%20faces&width=1280&height=720&seq=chigua-hangye03&orientation=landscape",
    content: [
      "一批平均年龄只有二十出头的年轻创业团队，最近把目光瞄向了那些地段不差、生意却冷清的传统小店。他们的「产品」很简单——用一套改造套餐，帮老板把门店外观、菜单设计、线上团购和短视频宣传一次性盘活。",
      "据团队成员介绍，很多老店老板不缺手艺，缺的是一扇「能让人走进来的门」。他们从门头、灯光、招牌这些「面子」改起，再帮店家把招牌菜品做成更适合拍图晒圈的「颜值款」，最后开通线上引流入口，让附近的人先刷到、再走进来。",
      "由于客单价不高、见效直观，这门「改造生意」在小店主之间口口相传，订单已经排到了下个月。有老板打趣：「花一杯咖啡的钱，请回一群懂年轻人的参谋，值了。」",
      "理性吃瓜提示：线下小店焕新的故事背后，是实体商业与年轻审美的一次次双向奔赴，也为传统生意提供了新的解题思路。",
    ],
  },
];

export const trending: { rank: number; id: string; title: string; heat: string }[] = [
  { rank: 1, id: "yule-01", title: "顶流男团巡演被曝「假唱疑云」，粉丝现场实拍引热议", heat: "热 · 986万" },
  { rank: 2, id: "shehui-01", title: "开了十二年的早餐摊歇业，熟客排队留字条致谢看哭路人", heat: "热 · 923万" },
  { rank: 3, id: "wangluo-01", title: "主播口误把品牌念成谐音梗，自嘲补救反而卖到断货", heat: "热 · 751万" },
  { rank: 4, id: "hangye-01", title: "大厂员工晒「佛系下班」走红，年轻人拒绝无效加班", heat: "热 · 587万" },
  { rank: 5, id: "shehui-02", title: "地铁「让座风波」再引热议：道德绑架还是礼让缺失", heat: "热 · 615万" },
  { rank: 6, id: "yule-02", title: "时隔八年老搭档再度同框，红毯旧照被考古翻红", heat: "热 · 541万" },
  { rank: 7, id: "wangluo-03", title: "「素颜挑战」翻车合集刷屏，网友：原来大家都一样", heat: "热 · 446万" },
  { rank: 8, id: "hangye-02", title: "奶茶「半杯都是冰」遭吐槽，官方宣布上线去冰加量", heat: "热 · 463万" },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: "「今天吃瓜」的内容都来自哪里？",
    a: "我们聚合整理来自公开网络、社交平台与新闻资讯中的热议话题，编辑团队会对信息进行筛选、交叉比对与语言重组后以「网络热议内容整理」的方式呈现，帮助大家在同一处快速浏览事件脉络。",
  },
  {
    q: "网站上看到的爆料都是真的吗？",
    a: "不一定是。吃瓜内容天然带有爆料与传播属性，很多信息在官方或当事人回应前都属于「传闻待证」。我们鼓励大家理性看待，遇到未证实的信息请以权威渠道与官方说明为准。",
  },
  {
    q: "如果我的权益在内容中受到影响怎么办？",
    a: "我们尊重事实与当事人的合法权益。若你发现某条内容对自身或所在主体造成误解或困扰，可通过站内「联系我们」页面的表单与我们取得联系，我们会在核实后及时处理并给出反馈。",
  },
  {
    q: "我能投稿或爆料吗？怎么联系到你们？",
    a: "当然可以。你可以在「联系我们」页填写反馈与报料表单，附上尽量清晰的时间、地点与事件经过（可附公开渠道链接），我们的编辑会认真阅读每一份来稿，并在筛选后跟进。",
  },
  {
    q: "内容会更新吗？多久能看一次新瓜？",
    a: "会的。我们会在各平台上持续跟踪话题热度，按天更新「今日热榜」与「最新吃瓜爆料」，重点话题会持续跟进事件后续。欢迎常回来看看，也别忘了把站点分享给同样爱吃瓜的朋友。",
  },
];

export const tags = [
  "男团",
  "演唱会",
  "素颜挑战",
  "让座",
  "市井人情",
  "奶茶",
  "直播带货",
  "大厂加班",
  "回忆杀",
  "食堂一元菜",
  "考古名场面",
  "线下小店",
];